<template>
		<div class="footer flex-col flex-y-center">
				<div class="footer-box flex-col">
						<div class="flex-row flex-y-center" style="justify-content: space-between">
								<div class="footer-link flex-row">
										<template v-for="(item,index) in navList" :key="index">
												<div class="link-item flex-col"  v-if="item.children.length>0">
														<p>{{item.name}}</p>
														<ul class=" flex-col" >
																<a :href="item2.url" target="_blank" v-for="(item2,index2) in item.children" :key="index2">
																		{{item2.name}}
																</a>
														</ul>
												</div>
										</template>
										<!--<div class="link-item flex-col">
												<p>陆运服务</p>
												<ul class=" flex-col">
														<a href="https://www.imooc.com/u/1343480" target="_blank">陆运快线</a>
														<a href="https://coding.imooc.com/class/113.html" target="_blank">陆运慢线</a>
														<a href="https://coding.imooc.com/class/236.html" target="_blank">陆运大货</a>
												</ul>
										</div>
										<div class="link-item flex-col">
												<p>海运服务</p>
												<ul class=" flex-col">
														<a href="https://www.imooc.com/u/1343480" target="_blank">越南海运</a>
														<a href="https://coding.imooc.com/class/113.html" target="_blank">泰国海运</a>
														<a href="https://coding.imooc.com/class/236.html" target="_blank">马来西亚海运</a>
														<a href="https://coding.imooc.com/class/343.html" target="_blank">新加坡海运</a>
												</ul>
										</div>
										<div class="link-item flex-col">
												<p>问题解答</p>
												<ul class=" flex-col">
														<a href="https://www.imooc.com/u/1343480" target="_blank">包裹咨询</a>
														<a href="https://coding.imooc.com/class/113.html" target="_blank">关于付款咨询</a>
														<a href="https://coding.imooc.com/class/236.html" target="_blank">如何给您代付</a>
														<a href="https://coding.imooc.com/class/343.html" target="_blank">优惠券</a>
												</ul>
										</div>
										<div class="link-item flex-col">
												<p>仓库地址</p>
												<ul class=" flex-col">
														<a href="https://www.imooc.com/u/1343480" target="_blank">中国仓库</a>
														<a href="https://coding.imooc.com/class/113.html" target="_blank">越南仓库</a>
														<a href="https://coding.imooc.com/class/236.html" target="_blank">泰国仓库</a>
														<a href="https://coding.imooc.com/class/343.html" target="_blank">香港仓库</a>
												</ul>
										</div>
										<div class="link-item flex-col">
												<p>在线客服</p>
												<ul class=" flex-col">
														<a href="https://www.imooc.com/u/1343480" target="_blank">中国客服</a>
														<a href="https://coding.imooc.com/class/113.html" target="_blank">泰国客服</a>
														<a href="https://coding.imooc.com/class/236.html" target="_blank">越南客服</a>
												</ul>
										</div>-->
								</div>
								<img :src="imgUrl+setting.wechat_qr">
						</div>
				</div>
				<div class="copyright">
						<span>{{ setting.copyright}}</span>
				</div>

		</div>
</template>
<script>
import {computed, getCurrentInstance, onMounted,ref} from "vue";

export default {
		name: 'nav-footer',
		setup() {
				const {proxy} = getCurrentInstance();
				const imgUrl=proxy.$imgUrl;
				const navList=ref([]);
				let setting = computed(() => {
						return proxy.$store.state.setting;
				});
				// 初始化接口
				onMounted(() => {
						getBottomNav();
				});
				function getBottomNav(){
						proxy.$axios.get("/home/getColumnList", {
								params: {
										is_bottom:1
								},
						}).then((res) => {
								console.log("getBottomNav",res);
								navList.value = res.data;
						});
				}
				return {
						setting,
						navList,
						imgUrl
				};
		}
}
</script>
<style lang="scss" scoped>
.footer {
		background-color: #ffce0e;
		color: #000000;
		font-size: 16px;
		text-align: center;

		.footer-box{
				width: 1227px;
				margin: 50px 0 30px;
				.footer-link {
						justify-content: space-between;
						width: 1000px;
						.link-item{
								text-align: left;
								p{
										color: #000000;
										font-weight: bold;
										font-size: 22px;
								}
								ul{
										a{
												display: inline-block;
												color: #333333;
												font-size:18px;
												&:hover{
														color: #fb512d;
												}
										}
								}
						}

						span {
								margin: 0 10px;
						}

						margin-bottom: 13px;
				}
				img{
						width: 150px;
						height: 150px;
						background: #ffffff;
						border-radius: 10px;
						overflow: hidden;
				}
		}
		.copyright {
				background: #020202;
				width: 100%;
				height: 50px;
				line-height: 50px;
				color: #ffffff;
				span{
						margin-left: 10px;
				}
		}

}
</style>
